/** Rutas de ayuda estática (frontend/public/ayuda → /ayuda/ en prod). */
const base = `${process.env.PUBLIC_URL || ''}/ayuda`;

export const HELP_URLS = {
  index: `${base}/`,
  comoFichar: `${base}/como-fichar.html`,
  agregarIcono: `${base}/agregar-icono-home.html`,
};

export const openHelp = (url) => {
  window.open(url, '_blank', 'noopener,noreferrer');
};
